<p-breadcrumb [model]="items"></p-breadcrumb>
<h1 class="heading-text">Configuration Profile for <span>{{accountName}}</span></h1>
<div class="setupDetailWrapper">
  <form [formGroup]="configForm" #form="ngForm">
    <div class="configureField">
      <div class="setup-section">
        <div class="form-group">
          <label for="profileName">Profile Name:<span class="required">*</span></label>
          <div class="control-wrapper">
            <input type="text" id="profileName" name="profileName" formControlName="profileName" placeholder="" required
              class="form-control form-control-sm"
              [class.is-invalid]="configForm.controls['profileName'].invalid && (configForm.controls['profileName'].dirty || configForm.controls['profileName'].touched)">
            <div
              *ngIf="configForm.controls['profileName'].invalid && (configForm.controls['profileName'].dirty || configForm.controls['profileName'].touched)"
              class="invalid-feedback">
              <div *ngIf="configForm.controls['profileName'].errors?.['required']">
                This field is required.
              </div>
              <div *ngIf="configForm.controls['profileName'].errors?.['pattern']">
                Alphabates Allowed only
              </div>
              <div *ngIf="configForm.controls['profileName'].errors?.['maxlength']">
                Profile Name must not exceed {{configForm.controls['profileName'].errors?.['maxlength']?.requiredLength}} characters.
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="descriptionNote">Description / Note: </label>
          <div class="control-wrapper descriptionNote">
            <textarea type="text" id="descriptionNote" name="descriptionNote" formControlName="descriptionNote"
              placeholder="" class="form-control form-control-sm"
              [class.is-invalid]="configForm.controls['descriptionNote'].invalid && 
              (configForm.controls['descriptionNote'].dirty || configForm.controls['descriptionNote'].touched)"></textarea>
            <div *ngIf="configForm.controls['descriptionNote'].invalid && 
              (configForm.controls['descriptionNote'].dirty || configForm.controls['descriptionNote'].touched)"
              class="invalid-feedback">
              <div *ngIf="configForm.controls['descriptionNote'].errors?.['required']">
                This field is required.
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="ismonitoringEnabled">Monitoring Enabled:</label>
          <div class="control-wrapper">
            <input type="radio" value="false" formControlName="monitoringEnabled">
            <span class="mr-2">No</span>
            <input type="radio" value="true" formControlName="monitoringEnabled">
            <span>Yes</span>
          </div>
        </div>

        <div class="additionalField defaultConfig">
          <div class="form-group">
            <label for="defaultConfig">Default Config:</label>
            <div class="control-wrapper">
              <input type="radio" value="true" formControlName="defaultConfig">
              <span class="mr-2">Yes</span>
              <input type="radio" value="false" formControlName="defaultConfig">
              <span class="mr-2">No</span>
            </div>
          </div>
        </div>
      </div>
      <div class="additionalField profileStatus">
        <div class="form-group">
          <label for="profileStatus">Status:</label>
          <div class="control-wrapper">
            <input type="radio" value="Published" formControlName="profileStatus">
            <span class="mr-2">Publish</span>
            <input type="radio" value="Draft" formControlName="profileStatus">
            <span class="mr-2">Draft</span>
            <span *ngIf="isUpdating">
              <input type="radio" value="Disabled" formControlName="profileStatus">
              <span class="mr-2">Disabled</span>
            </span>
          </div>
        </div>
        <div class="form-group">
          <span class="col-sm-4 col-form-label">Custom List:</span>
          <div class="control-wrapper">
            {{customList ? 'Yes' : 'No'}}
          </div>
        </div>
        <div class="form-group" *ngIf="ifUser">
          <span class="col-sm-4 col-form-label">WLS Split Enable:</span>
          <div class="value configStatus">
            <input type="checkbox" [checked]="is_WLS_Enable" (change)="changed($event)" id="no"/>
          </div>
        </div>
      </div>
    </div>
    <div class="tabLayout-wrapper" *ngIf="watchLists_sanc.tabStatus">
      <p-tabView>
        <p-tabPanel header="Watchlists & Sanctions" *ngIf="watchLists_sanc.tabStatus && is_WLS_Enable === false">
          <div formGroupName="watchlistAndSanctions">
            <div formGroupName="customListOptions" *ngIf="!isDiligent">
              <div class="form-group" *ngIf="customList">
                <label for="customListCheck" class="customListCheck">Custom List </label>
                <div class="control-wrapper">
                  <input type="checkbox" id="customListCheck" name="customListCheck" class="custom"
                    formControlName="customListEnabled"
                    (change)="onCustomListChange(configForm.get('watchlistAndSanctions.customListOptions.customListEnabled')?.value, 'watchlistAndSanctions')">
                </div>
              </div>
              <div class="setup-section downloadWrapper" *ngIf="show_WS_CustomListSection">
                <div class="form-group">
                  <label for="customListFileName" class="col-sm-4 col-form-label">Custom List Name: <span
                      class="required">*</span></label>
                  <div class="control-wrapper">
                    <input type="text" id="customListFileName" name="customListFileName" formControlName="customListFileName"
                      placeholder="" required class="form-control form-control-sm"
                      [class.is-invalid]="configForm.get('watchlistAndSanctions.customListOptions.customListFileName')?.invalid && (configForm.get('watchlistAndSanctions.customListOptions.customListFileName')?.dirty || configForm.get('watchlistAndSanctions.customListOptions.customListFileName')?.touched)">
                    <div
                      *ngIf="configForm.get('watchlistAndSanctions.customListOptions.customListFileName')?.invalid || (configForm.get('watchlistAndSanctions.customListOptions.customListFileName')?.dirty || configForm.get('watchlistAndSanctions.customListOptions.customListFileName')?.touched)"
                      class="invalid-feedback">
                      <div
                        *ngIf="configForm.get('watchlistAndSanctions.customListOptions.customListFileName')?.errors?.['required']">
                        This field is required.
                      </div>
                      <div
                        *ngIf="configForm.get('watchlistAndSanctions.customListOptions.customListFileName')?.errors?.['pattern']">
                        Please enter valid list Name. (Letters and numbers allowed only)
                      </div>
                      <div
                        *ngIf="configForm.get('watchlistAndSanctions.customListOptions.customListFileName')?.errors?.['maxlength']">
                        List Name must not exceed
                        {{configForm.get('watchlistAndSanctions.customListOptions.accountName')?.errors?.['maxlength']?.requiredLength}}
                        characters.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-4 col-form-label">Download the Custom List&nbsp;<a class="link" href="/assets/CustomListTemplate.csv">Template</a>&nbsp;or Upload your file below
                    <span class="required">*</span>
                  </label>
                  <div class="control-wrapper customListFile" 
                       (dragover)="onDragOver($event)" 
                       (dragleave)="onDragLeave($event)"
                       (drop)="onDropSuccess($event, 'watchlistAndSanctions')"
                       [class.is-dragover]="isDragOver">
                    <div class="dragDropWrap">
                      <div class="iconHolder"><i class="pi" [ngClass]="{'pi-upload': !selectedWatchSancFile, 'pi-file': selectedWatchSancFile}"></i></div>
                      <span>Drag and drop file here to upload <br>
                        or <label for="customListFile1" class="browseFiles link">Browse files</label> 
                      </span>
                    </div>
            
                  </div>
                  <div class="customListFile">
                    <input type="file" class="form-control" id="customListFile1" accept=".csv" formControlName="customListFile"
                      (change)="onFileSelected($event, 'watchlistAndSanctions')"
                      [class.is-invalid]="configForm.get('watchlistAndSanctions.customListOptions.customListFile')?.invalid && (configForm.get('watchlistAndSanctions.customListOptions.customListFile')?.dirty || configForm.get('watchlistAndSanctions.customListOptions.customListFile')?.touched)">
                    <div
                      *ngIf="configForm.get('watchlistAndSanctions.customListOptions.customListFile')?.errors?.['required'] && (configForm.get('watchlistAndSanctions.customListOptions.customListFile')?.touched || form.submitted) && !selectedWatchSancFile"
                      class="invalid-feedback">
                      Please Upload Source list file in CSV format.
                    </div>
                  </div>
                  <div *ngIf="selectedWatchSancFile" class="selected-file-name">
                    Selected File: {{ selectedWatchSancFile.name }}
                  </div>
                  <div class="dowloadFileReqText">Format Requirements: 
                    The format of your uploaded spreadsheet (.csv) must be in UTF-8. File size cannot exceed 10k records
                  </div>
                </div>
              </div>
            </div>
            <div class="setup-section" *ngIf="!show_WS_CustomListSection">
              <div class="form-group">
                <label for="timeFrame" class="timeFrameLabel">Time Frame for Searches : </label>
                <div class="control-wrapper">
                  <select class="form-control" id="timeFrame" formControlName="timeFrame" class="timeFrame">
                    <option *ngFor="let element of watchLists_sanc.timeFrame" [ngValue]="element.code">{{element.description}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" *ngIf="watchLists_sanc?.customListOptions?.customListEnabled && isUpdating">
                <label for="customListId" class=" ">Use Custom List ID:</label>
                <div class="control-wrapper customListId">
                  <input type="text" id="customListId" name="customListId" formControlName="customListId" placeholder=""
                    class="form-control form-control-sm">
                </div>
              </div>
              <div class="form-group categoryControl">
                <label for="categories">Product Categories: </label>
                <div class="control-wrapper">
                  <p-multiSelect [options]="watchLists_sanc.categories" [group]="true" defaultLabel="Selection required"
                    scrollHeight="400px" [selectedItemsLabel]="'{0} items selected'" formControlName="categories"
                    [showToggleAll]="false" [filter]="false">
                    <ng-template let-group pTemplate="group">
                      <div class="flex align-items-center">
                        <input type="checkbox" class="custom"
                          [checked]="selectedGroupLength(group.value, 'watchlistAndSanctions.categories', group.items.length)"
                          (click)="setSelection($event, group.items, 'watchlistAndSanctions.categories')">
                        <span>{{group.label}}</span>
                      </div>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                      <div class="content">{{item.label}} </div>
                      <i class="pi pi-info-circle" pTooltip="{{item?.tooltip}}" tooltipPosition="top"></i>
                    </ng-template>
                  </p-multiSelect>
                </div>
              </div>
              <div class="form-group subCategoryControl">
                <label for="categories">Sub Categories: </label>
                <div class="control-wrapper">
                  <div *ngFor="let choice of watchLists_sanc.subProducts; let i=index">
                    <span>
                      <input type="checkbox" class="custom" [checked]="choice?.defaultOption || choice?.selected"
                        [value]="choice.code" (change)="onCheckChange($event, 'watchlistAndSanctions.subProducts')">
                      {{choice.description}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Sanctions" *ngIf="sanctions.tabStatus && is_WLS_Enable === true">
          <div formGroupName="sanctions">
            <div formGroupName="customListOptions">
              <div class="form-group" *ngIf="customList">
                <label for="customListCheck" class="customListCheck">Custom List </label>
                <div class="control-wrapper">
                  <input type="checkbox" id="customListCheck" name="customListCheck" class="custom"
                    formControlName="customListEnabled"
                    (change)="onCustomListChange(configForm.get('sanctions.customListOptions.customListEnabled')?.value, 'sanctions')">
                </div>
              </div>
              <div class="setup-section downloadWrapper" *ngIf="show_S_CustomListSection">
                <div class="form-group">
                  <label for="customListFileName" class="col-sm-4 col-form-label">Custom List Name: <span
                      class="required">*</span></label>
                  <div class="control-wrapper">
                    <input type="text" id="customListFileName" name="customListFileName" formControlName="customListFileName"
                      placeholder="" required class="form-control form-control-sm"
                      [class.is-invalid]="configForm.get('sanctions.customListOptions.customListFileName')?.invalid && (configForm.get('sanctions.customListOptions.customListFileName')?.dirty || configForm.get('sanctions.customListOptions.customListFileName')?.touched)">
                    <div
                      *ngIf="configForm.get('sanctions.customListOptions.customListFileName')?.invalid || (configForm.get('sanctions.customListOptions.customListFileName')?.dirty || configForm.get('sanctions.customListOptions.customListFileName')?.touched)"
                      class="invalid-feedback">
                      <div
                        *ngIf="configForm.get('sanctions.customListOptions.customListFileName')?.errors?.['required']">
                        This field is required.
                      </div>
                      <div
                        *ngIf="configForm.get('sanctions.customListOptions.customListFileName')?.errors?.['pattern']">
                        Please enter valid list Name. (Letters and numbers allowed only)
                      </div>
                      <div
                        *ngIf="configForm.get('sanctions.customListOptions.customListFileName')?.errors?.['maxlength']">
                        List Name must not exceed
                        {{configForm.get('sanctions.customListOptions.accountName')?.errors?.['maxlength']?.requiredLength}}
                        characters.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-4 col-form-label">Download the Custom List&nbsp;<a class="link" href="/assets/CustomListTemplate.csv">Template</a>&nbsp;or Upload your file below
                    <span class="required">*</span>
                  </label>
                  <div class="control-wrapper customListFile" 
                       (dragover)="onDragOver($event)" 
                       (dragleave)="onDragLeave($event)"
                       (drop)="onDropSuccess($event, 'sanctions')"
                       [class.is-dragover]="isDragOver">
                    <div class="dragDropWrap">
                      <div class="iconHolder"><i class="pi" [ngClass]="{'pi-upload': !selectedSancFile, 'pi-file': selectedSancFile}"></i></div>
                      <span>Drag and drop file here to upload <br>
                        or <label for="customListFile3" class="browseFiles link">Browse files</label> 
                      </span>
                    </div>
            
                  </div>
                  <div class="customListFile">
                    <input type="file" class="form-control" id="customListFile3" accept=".csv" formControlName="customListFile"
                      (change)="onFileSelected($event, 'sanctions')"
                      [class.is-invalid]="configForm.get('sanctions.customListOptions.customListFile')?.invalid && (configForm.get('sanctions.customListOptions.customListFile')?.dirty || configForm.get('sanctions.customListOptions.customListFile')?.touched)">
                    <div
                      *ngIf="configForm.get('sanctions.customListOptions.customListFile')?.errors?.['required'] && (configForm.get('sanctions.customListOptions.customListFile')?.touched || form.submitted) && !selectedSancFile"
                      class="invalid-feedback">
                      Please Upload Source list file in CSV format.
                    </div>
                  </div>
                  <div *ngIf="selectedSancFile" class="selected-file-name">
                    Selected File: {{ selectedSancFile.name }}
                  </div>
                  <div class="dowloadFileReqText">Format Requirements: 
                    The format of your uploaded spreadsheet (.csv) must be in UTF-8. File size cannot exceed 10k records
                  </div>
                </div>
              </div>
            </div>
            <div class="setup-section" *ngIf="!show_S_CustomListSection">
              <div class="form-group" *ngIf="!isDiligent">
                <label for="timeFrame" class="timeFrameLabel">Time Frame for Searches : </label>
                <div class="control-wrapper">
                  <select class="form-control" id="timeFrame" formControlName="timeFrame" class="timeFrame">
                    <option *ngFor="let element of sanctions.timeFrame" [ngValue]="element.code">{{element.description}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" *ngIf="sanctions?.customListOptions?.customListEnabled && isUpdating && !isDiligent">
                <label for="customListId" class=" ">Use Custom List ID:</label>
                <div class="control-wrapper customListId">
                  <input type="text" id="customListId" name="customListId" formControlName="customListId" placeholder=""
                    class="form-control form-control-sm">
                </div>
              </div>
              <div class="form-group categoryControl">
                <label for="categories">Product Categories: </label>
                <div class="control-wrapper">
                  <p-multiSelect [options]="sanctions.categories" [group]="true" defaultLabel="Selection required"
                    scrollHeight="400px" [selectedItemsLabel]="'{0} items selected'" formControlName="categories"
                    [showToggleAll]="false" [filter]="false">
                    <ng-template let-group pTemplate="group">
                      <div class="flex align-items-center">
                        <input type="checkbox" class="custom"
                          [checked]="selectedGroupLength(group.value, 'sanctions.categories', group.items.length)"
                          (click)="setSelection($event, group.items, 'sanctions.categories')">
                        <span>{{group.label}}</span>
                      </div>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                      <div class="content">{{item.label}} </div>
                      <i class="pi pi-info-circle" pTooltip="{{item?.tooltip}}" tooltipPosition="top"></i>
                    </ng-template>
                  </p-multiSelect>
                </div>
              </div>
              <div class="form-group subCategoryControl" *ngIf="!isDiligent">
                <label for="categories">Sub Categories: </label>
                <div class="control-wrapper">
                  <div *ngFor="let choice of sanctions.subProducts; let i=index">
                    <span>
                      <input type="checkbox" class="custom" [checked]="choice?.defaultOption || choice?.selected"
                        [value]="choice.code" (change)="onCheckChange($event, 'sanctions.subProducts')">
                      {{choice.description}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Watchlists" *ngIf="watchLists.tabStatus && is_WLS_Enable === true">
          <div formGroupName="watchlists">
            <div formGroupName="customListOptions" *ngIf="!isDiligent">
              <div class="form-group" *ngIf="customList">
                <label for="customListCheck" class="customListCheck">Custom List </label>
                <div class="control-wrapper">
                  <input type="checkbox" id="customListCheck" name="customListCheck" class="custom"
                    formControlName="customListEnabled"
                    (change)="onCustomListChange(configForm.get('watchlists.customListOptions.customListEnabled')?.value, 'watchlists')">
                </div>
              </div>
              <div class="setup-section downloadWrapper" *ngIf="show_W_CustomListSection">
                <div class="form-group">
                  <label for="customListFileName" class="col-sm-4 col-form-label">Custom List Name: <span
                      class="required">*</span></label>
                  <div class="control-wrapper">
                    <input type="text" id="customListFileName" name="customListFileName" formControlName="customListFileName"
                      placeholder="" required class="form-control form-control-sm"
                      [class.is-invalid]="configForm.get('watchlists.customListOptions.customListFileName')?.invalid && (configForm.get('watchlists.customListOptions.customListFileName')?.dirty || configForm.get('watchlists.customListOptions.customListFileName')?.touched)">
                    <div
                      *ngIf="configForm.get('watchlists.customListOptions.customListFileName')?.invalid || (configForm.get('watchlists.customListOptions.customListFileName')?.dirty || configForm.get('watchlists.customListOptions.customListFileName')?.touched)"
                      class="invalid-feedback">
                      <div
                        *ngIf="configForm.get('watchlists.customListOptions.customListFileName')?.errors?.['required']">
                        This field is required.
                      </div>
                      <div
                        *ngIf="configForm.get('watchlists.customListOptions.customListFileName')?.errors?.['pattern']">
                        Please enter valid list Name. (Letters and numbers allowed only)
                      </div>
                      <div
                        *ngIf="configForm.get('watchlists.customListOptions.customListFileName')?.errors?.['maxlength']">
                        List Name must not exceed
                        {{configForm.get('watchlists.customListOptions.accountName')?.errors?.['maxlength']?.requiredLength}}
                        characters.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                 <label class="col-sm-4 col-form-label">Download the Custom List&nbsp;<a class="link" href="/assets/CustomListTemplate.csv">Template</a>&nbsp;or Upload your file below
                    <span class="required">*</span>
                  </label>
                  <div class="control-wrapper customListFile" 
                       (dragover)="onDragOver($event)" 
                       (dragleave)="onDragLeave($event)"
                       (drop)="onDropSuccess($event, 'watchlists')"
                       [class.is-dragover]="isDragOver">
                    <div class="dragDropWrap">
                      <div class="iconHolder"><i class="pi" [ngClass]="{'pi-upload': !selectedWatchFile, 'pi-file': selectedWatchFile}"></i></div>
                      <span>Drag and drop file here to upload <br>
                        or <label for="customListFile2" class="browseFiles link">Browse files</label> 
                      </span>
                    </div>
            
                  </div>
                  <div class="customListFile">
                    <input type="file" class="form-control" id="customListFile2" accept=".csv" formControlName="customListFile"
                      (change)="onFileSelected($event, 'watchlists')"
                      [class.is-invalid]="configForm.get('watchlists.customListOptions.customListFile')?.invalid && (configForm.get('watchlists.customListOptions.customListFile')?.dirty || configForm.get('watchlists.customListOptions.customListFile')?.touched)">
                    <div
                      *ngIf="configForm.get('watchlists.customListOptions.customListFile')?.errors?.['required'] && (configForm.get('watchlists.customListOptions.customListFile')?.touched || form.submitted) && !selectedWatchFile"
                      class="invalid-feedback">
                      Please Upload Source list file in CSV format.
                    </div>
                  </div>
                  <div *ngIf="selectedWatchFile" class="selected-file-name">
                    Selected File: {{ selectedWatchFile.name }}
                  </div>
                  <div class="dowloadFileReqText">Format Requirements: 
                    The format of your uploaded spreadsheet (.csv) must be in UTF-8. File size cannot exceed 10k records
                  </div>
                </div>
              </div>
            </div>
            <div class="setup-section" *ngIf="!show_W_CustomListSection">
              <div class="form-group" *ngIf="!isDiligent">
                <label for="timeFrame" class="timeFrameLabel">Time Frame for Searches : </label>
                <div class="control-wrapper">
                  <select class="form-control" id="timeFrame" formControlName="timeFrame" class="timeFrame">
                    <option *ngFor="let element of watchLists.timeFrame" [ngValue]="element.code">{{element.description}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group" *ngIf="watchLists?.customListOptions?.customListEnabled && isUpdating && !isDiligent">
                <label for="customListId" class=" ">Use Custom List ID:</label>
                <div class="control-wrapper customListId">
                  <input type="text" id="customListId" name="customListId" formControlName="customListId" placeholder=""
                    class="form-control form-control-sm">
                </div>
              </div>
              <div class="form-group categoryControl">
                <label for="categories">Product Categories: </label>
                <div class="control-wrapper">
                  <p-multiSelect [options]="watchLists.categories" [group]="true" defaultLabel="Selection required"
                    scrollHeight="400px" [selectedItemsLabel]="'{0} items selected'" formControlName="categories"
                    [showToggleAll]="false" [filter]="false">
                    <ng-template let-group pTemplate="group">
                      <div class="flex align-items-center">
                        <input type="checkbox" class="custom"
                          [checked]="selectedGroupLength(group.value, 'watchlists.categories', group.items.length)"
                          (click)="setSelection($event, group.items, 'watchlists.categories')">
                        <span>{{group.label}}</span>
                      </div>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                      <div class="content">{{item.label}} </div>
                      <i class="pi pi-info-circle" pTooltip="{{item?.tooltip}}" tooltipPosition="top"></i>
                    </ng-template>
                  </p-multiSelect>
                </div>
              </div>
              <div class="form-group subCategoryControl" *ngIf="!isDiligent">
                <label for="categories">Sub Categories: </label>
                <div class="control-wrapper">
                  <div *ngFor="let choice of watchLists.subProducts; let i=index">
                    <span>
                      <input type="checkbox" class="custom" [checked]="choice?.defaultOption || choice?.selected"
                        [value]="choice.code" (change)="onCheckChange($event, 'watchlists.subProducts')">
                      {{choice.description}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
        
        <p-tabPanel header="Political Exposure" *ngIf="political.tabStatus">
          <div formGroupName="politicalAffiliations">
            <div class="setup-section">
              <div class="form-group categoryControl">
                <label for="categories">PEPDesk Categories: </label>
                <div class="control-wrapper">
                  <p-multiSelect [options]="political.categories" defaultLabel="Selection required" scrollHeight="350px"
                    [selectedItemsLabel]="'{0} items selected'" formControlName="categories" [showToggleAll]="false"
                    [filter]="false" class="not-grouped">
                    <ng-template let-item pTemplate="item">
                      <div>{{item.label}}</div>
                    </ng-template>
                  </p-multiSelect>
                </div>
              </div>
              <div class="form-group subCategoryControl">
                <label for="categories">Sub Categories: </label>
                <div class="control-wrapper">
                  <div *ngFor="let choice of political.subProducts; let i=index">
                    <span>
                      <input type="checkbox" class="custom" [value]="choice.code"
                        [checked]="choice?.defaultOption || choice?.selected"
                        (change)="onCheckChange($event, 'politicalAffiliations.subProducts')">
                      {{choice.description}}
                    </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </p-tabPanel>
        <p-tabPanel header="Diligent SOE" *ngIf="diligentSOE?.code">
          <div>
            <div class="setup-section">
              <div class="form-group categoryControl">
                <label>Diligent SOE Categories: </label>
                <div class="control-wrapper">
                  <div class="categoryWrapper">
                    <div class="category" *ngFor="let category of diligentSOE.categories">
                      <div class="parent">
                        <input type="checkbox" class="custom" [checked]="category.selected" disabled>
                        {{category.description}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Adverse Media" *ngIf="adverseMedia.tabStatus">
          <div formGroupName="adverseMedia">
            <div class="setup-section">
              <div class="form-group">
                <label for="timeFrame" class="timeFrameLabel">Time Frame for Searches : </label>
                <div class="control-wrapper">
                  <select class="form-control" id="timeFrame" formControlName="timeFrame" class="timeFrame">
                    <option *ngFor="let element of watchLists_sanc.timeFrame" [ngValue]="element.code">{{element.description}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group categoryControl">
                <label for="categories">Geographic Coverage:</label>
                <div class="control-wrapper">
                  <p-multiSelect [options]="adverseMedia.categories" [group]="true" defaultLabel="Selection required"
                    scrollHeight="400px" [selectedItemsLabel]="'{0} items selected'" formControlName="categories"
                    [showToggleAll]="false" [filter]="false">
                    <ng-template let-group pTemplate="group">
                      <div class="flex align-items-center">
                        <input type="checkbox" class="custom"
                          [checked]="selectedGroupLength(group.value, 'adverseMedia.categories', group.items.length)"
                          (click)="setSelection($event, group.items, 'adverseMedia.categories')">
                        <span>{{group.label}}</span>
                      </div>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                      <div>{{item.label}}</div>
                    </ng-template>
                  </p-multiSelect>
                </div>
              </div>

              <div class="form-group categoryControl">
                <label for="eventTypes">Event Types:</label>
                <div class="control-wrapper">
                  <p-multiSelect [options]="adverseMedia.eventTypes" [group]="true" defaultLabel="Selection required"
                    scrollHeight="400px" [selectedItemsLabel]="'{0} items selected'" formControlName="eventTypes"
                    [showToggleAll]="false" [filter]="false">
                    <ng-template let-group pTemplate="group">
                      <div class="flex align-items-center">
                        <input type="checkbox" class="custom"
                          [checked]="selectedGroupLength(group.value, 'adverseMedia.eventTypes', group.items.length)"
                          (click)="setSelection($event, group.items, 'adverseMedia.eventTypes')">
                        <span>{{group.label}}</span>
                      </div>
                    </ng-template>
                    <ng-template let-item pTemplate="item">
                      <div class="content">{{item.label}} </div>
                      <i class="pi pi-info-circle" pTooltip="{{item?.tooltip}}" tooltipPosition="top"></i>
                    </ng-template>
                  </p-multiSelect>
                </div>
                <div class="form-group" *ngFor="let choice of adverseMedia.subProducts; let i=index">
                  <span>
                    <input type="checkbox" [value]="choice.code" class="custom"
                      (change)="onCheckChange($event, 'adverseMedia.subProducts')">
                    {{choice.description}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="User Data">
          <div>
            <app-list-datasets (dataEvent)="handleJson($event)" [accountId]="accountId" [enrollmentId]="enrollmentId"></app-list-datasets>
          </div>
        </p-tabPanel>
      </p-tabView>
      <button class="button submitButton mr-2" (click)="submitForm()">Save</button>
      <a routerLink="/" class="button">Cancel</a>
    </div>
  </form>
</div>

<p-dialog [(visible)]="displayDataset" [modal]="true" [style]="{width: '80vw'}" header="User Dataset Details">
    <app-view-datasets [datasetId]="selectedDatasetId"></app-view-datasets>
</p-dialog>

<p-dialog [(visible)]="createDataset" [modal]="true" [style]="{width: '80vw'}" header="User Dataset Profile Setup">
    <app-create-datasets [accountId]="''+accountId" [fileName]="selectedFileName"></app-create-datasets>
</p-dialog>

